export default "__VITE_ASSET__dc6a7f29__"